import React from "react";
import { Clock, Infinity as InfinityIcon } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Slider } from "@/components/ui/slider";

// Cook-time slider: 5 discrete positions. Index 4 = no limit (null).
export const COOK_TIME_OPTIONS = [15, 30, 45, 60, null];

// Shared cook-time limit slider. Holds an index (0..4) into COOK_TIME_OPTIONS;
// callers derive minutes via COOK_TIME_OPTIONS[valueIdx] (null = no limit).
export default function CookTimeSlider({ valueIdx, onChange, disabled = false, className = "" }) {
  const { t } = useLanguage();
  const maxCookTime = COOK_TIME_OPTIONS[valueIdx];

  return (
    <div className={className} data-testid="cook-time-slider">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-1.5 text-[#6B705C] text-sm font-body">
          <Clock className="w-4 h-4" strokeWidth={1.5} />
          {t("cookTimeLabel")}
        </div>
        <div className="text-[#4A6B4E] text-sm font-body font-bold flex items-center">
          {maxCookTime === null
            ? <InfinityIcon className="w-4 h-4" strokeWidth={2} />
            : `${maxCookTime} ${t("min")}`}
        </div>
      </div>
      <Slider
        value={[valueIdx]}
        onValueChange={(v) => onChange(v[0])}
        min={0}
        max={4}
        step={1}
        disabled={disabled}
        aria-label={t("cookTimeLabel")}
      />
      <div className="flex justify-between mt-1.5 text-[10px] text-[#A5A58D] font-body">
        <span>15</span><span>30</span><span>45</span><span>60</span>
        <span>{t("cookTimeNoLimit")}</span>
      </div>
    </div>
  );
}
